import {
  ADD_ADMIN,
  ADD_ADMIN_EMAIL,
  ADD_ADMIN_EMAIL_ERROR,
  ADD_ADMIN_EMAIL_SUCCESS,
  ADD_ADMIN_ERROR,
  ADD_ADMIN_SUCCESS,
  AdminActions,
  FETCH_ADMIN_LIST,
  FETCH_ADMIN_LIST_ERROR,
  FETCH_ADMIN_LIST_SUCCESS,
  REMOVE_ADMIN_SUCCESS,
} from '../../types/actions/Admin.actions';
import {IAdmin} from '../../types/models/Admin';

export interface AdminState {
  data: IAdmin[] | null;
  isLoading: boolean;
  isSaving: boolean;
}

const initialState: AdminState = {
  isSaving: false,
  isLoading: true,
  data: null,
};

export default (state = initialState, action: AdminActions): AdminState => {
  switch (action.type) {
    case FETCH_ADMIN_LIST: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case FETCH_ADMIN_LIST_SUCCESS: {
      return {
        isLoading: false,
        isSaving: false,
        data: action.payload,
      };
    }
    case FETCH_ADMIN_LIST_ERROR: {
      return {
        isLoading: false,
        isSaving: false,
        data: [],
      };
    }
    case ADD_ADMIN_EMAIL: {
      return {
        ...state,
        isSaving: true,
      };
    }
    case ADD_ADMIN_EMAIL_SUCCESS: {
      const newData = [...(state.data || [])];
      const index = newData.findIndex(
        ({address}) => address === action.payload.address,
      );

      if (index === -1) {
        newData.push(action.payload);
      } else {
        newData[index] = action.payload;
      }

      return {
        ...state,
        isSaving: false,
        data: newData,
      };
    }
    case ADD_ADMIN_EMAIL_ERROR: {
      return {
        ...state,
        isSaving: false,
      };
    }
    case ADD_ADMIN: {
      return {
        ...state,
        isSaving: true,
      };
    }
    case ADD_ADMIN_SUCCESS: {
      return {
        ...state,
        isSaving: false,
        data: [action.payload, ...(state.data || [])],
      };
    }
    case ADD_ADMIN_ERROR: {
      return {
        ...state,
        isSaving: false,
      };
    }
    case REMOVE_ADMIN_SUCCESS: {
      return {
        ...state,
        data: (state.data || []).filter(
          (admin) => admin.address !== action.payload,
        ),
      };
    }
    default:
      return state;
  }
};
